// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "d8ad84f74550";
export const BUILD_VERSION_NUMBER = 2;
